module.exports = __webpack_public_path__ + "assets/7212f5392ba22126a7a19b8c8b26d2c7.png";